"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockAnchoringException = exports.ConfirmationProofException = exports.SystemChainException = exports.ProofRidException = exports.SignatureException = exports.DifferentNumberOfSignersException = exports.MissingTransactionProof = void 0;
const formatter_1 = require("../formatter");
class MissingTransactionProof extends Error {
    constructor(proofHash, fetchedTxHash) {
        super(`Unable to verify source transaction proof,transaction hash in proof ${(0, formatter_1.toString)(proofHash)} does not match hash from fetched transaction ${(0, formatter_1.toString)(fetchedTxHash)}`);
    }
}
exports.MissingTransactionProof = MissingTransactionProof;
class DifferentNumberOfSignersException extends Error {
    constructor(length, comparableLength) {
        super(`Transaction signatures amount ${length} do not match expected amount of signers ${comparableLength}`);
    }
}
exports.DifferentNumberOfSignersException = DifferentNumberOfSignersException;
class SignatureException extends Error {
    constructor(signer) {
        super(`Expected signer ${(0, formatter_1.toString)(signer)} has not signed source transaction`);
    }
}
exports.SignatureException = SignatureException;
class ProofRidException extends Error {
    constructor() {
        super("Unable to verify source transaction proof, got a different transaction from query than we asked for");
    }
}
exports.ProofRidException = ProofRidException;
class SystemChainException extends Error {
    constructor(errorMessage) {
        super(`Query to system chain failed with error: ${errorMessage}`);
    }
}
exports.SystemChainException = SystemChainException;
class ConfirmationProofException extends Error {
    constructor(transactionRid) {
        super(`Unable to fetch confirmation proof for transaction RID: ${(0, formatter_1.ensureString)(transactionRid)}.`);
    }
}
exports.ConfirmationProofException = ConfirmationProofException;
class BlockAnchoringException extends Error {
    constructor() {
        super(`Block is not present in cluster anchoring chain`);
    }
}
exports.BlockAnchoringException = BlockAnchoringException;
//# sourceMappingURL=error.js.map